export default __webpack_public_path__ + "static/media/feature--businesses.dd89dc63.png";